<template>
    <div class="col-12 col-sm-9">
        <div class="header-bar">
            <h4>Geef je voorkeuren op</h4>
        </div>
        <div class="card-body">
            <div v-if="wait">
                <Loader text="Opties ophalen"></Loader>
            </div>
            <div v-else>
                <b-form-select
                    id="search-type"
                    v-model="$v.searchType.$model"
                    v-on:change="checkSearchType(searchType)"
                    class="form-control"
                >
                    <template v-slot:first>
                        <b-form-select-option
                            :value="null"
                            disabled
                        >
                            Selecteer zoekwijze
                        </b-form-select-option>
                    </template>
                    <b-form-select-option value="all">Eerst mogelijke opties zien</b-form-select-option>
                    <b-form-select-option value="preference">Voorkeurs dagen opgeven</b-form-select-option>
                    <b-form-select-option value="specific">Zoeken op een specifieke datum</b-form-select-option>
                </b-form-select>
                <span
                    class="error"
                    v-if="!$v.searchType.required && error"
                >Selecteer een zoekwijze</span>
            </div>
            <div
                id="day-time-select"
                class="card-body"
                v-if="searchType === 'preference'"
            >
                <table>
                    <tr>
                        <th>Vink aan op welke dagen u een afspraak wilt maken</th>
                    </tr>
                    <tr
                        v-for="day1 in daysOpenClosed"
                        v-bind:key="day1.id"
                    >
                        <td v-if="day1.show_in_appointmentsystem">
                            <input
                                type="checkbox"
                                :id="day1.day_number"
                                v-model="days[day1.day_number].enabled"
                            >
                            {{ days[day1.day_number].day }}
                        </td>
                    </tr>
                </table>
                <span
                    class="error"
                    v-if="noDaySelected && error"
                >Selecteer minimaal 1 dag</span>
            </div>
            <div
                id="specific-date"
                class="card-body"
                v-if="searchType === 'specific'"
            >
                <table>
                    <tr>
                        <th>Let op, u kunt tot maximaal {{ weeksAhead }} weken vooruit plannen.</th>
                    </tr>
                    <tr>
                        <td>Specifieke datum:</td>
                        <td>
                            <input
                                id="date-input"
                                type="date"
                                :min="minDate | moment('YYYY-MM-DD')"
                                :max="maxDate | moment('YYYY-MM-DD') "
                                v-model="$v.specificDate.$model"
                            >
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <span
                                class="error"
                                v-if="!$v.specificDate.required && error"
                            >Geef een datum op</span>
                        </td>
                    </tr>
                </table>
            </div>
            <div class="card-body d-flex justify-content-center">
                <b-col>
                    <GoBack></GoBack>
                </b-col>
                <b-col>
                    <div class="d-flex justify-content-center">
                        <button
                            id="continue"
                            class="btn btn-primary"
                            @click.once="submit"
                        >Ga verder
                        </button>
                    </div>
                </b-col>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import GoBack from './GoBack';
import {required} from 'vuelidate/lib/validators'
import calls from '../mixins/calls'
import appointmentOption from '../mixins/appointmentOption';
import Loader from './Loader/Loader';

export default {
    components: {GoBack, Loader},
    mixins: [calls, appointmentOption],
    created() {
        if (this.token) {
            this.tokenString = '&api-token=' + this.$store.state.token
        }
        this.$store.commit('resetDayArray', 'all')
        this.$store.commit('setAppointmentOptions', null)
        this.$store.commit('setLastRoute', 'date-selection')
        this.getDaysOpenClosed()
        if (this.$store.getters.getIdPatient == null) {
            this.getTempId()
        }
    },
    data() {
        return {
            days: this.$store.state.days,
            selectedEmployee: null,
            searchType: null,
            employeeOptions: [],
            specificDate: null,
            appointmentOptions: [],
            dataArray: [],
            treatment: '',
            tokenString: '',
            error: false,
            noDaySelected: false,
            wait: false,
        };
    },
    validations: {
        searchType: {
            required
        },
        specificDate: {
            required
        }
    },
    methods: {
        submit() {
            if (this.searchType === 'preference') {
                let checked = false
                this.days.forEach(function (day) {
                    if (day.enabled) {
                        checked = true
                    }
                })
                if (checked) {
                    this.getOptions()
                } else {
                    this.noDaySelected = true
                    this.error = true
                }
            } else if (this.searchType === 'all') {
                this.getOptions()
            } else if (this.searchType === 'specific') {
                if (this.specificDate) {
                    this.getOptions()
                } else {
                    this.error = true
                }
            } else {
                this.error = true
            }
        },
        getOptions: function () {
            this.checkSearchType(this.searchType)
            if (!this.rescheduleData.appointment) {
                this.setData()
            } else {
                this.rescheduleAppointment()
                this.getAppointmentOptions()
            }
        },
        rescheduleAppointment() {
            this.dataArray = {
                settlement: this.rescheduleData.idEstablishment,
                rescheduleAppointment: this.rescheduleData.appointment,
                days: this.days,
                preferredDate: this.specificDate,
            }
            this.$store.commit('setPostArray', this.dataArray)
        },
        setData: function () {
            let duration
            let date = new Date()
            let treatmentId
            //determine appointment duration if episode has an own set duration
            if (!this.intake) {
                treatmentId = this.selectedEpisode.treatment
            } else {
                treatmentId = this.selectedTreatment.idIntakeTreatment
            }

            //default duration from treatment data
            this.getTreatmentById(treatmentId).then(treatment => {
                duration = this.$moment(date.setHours(0, treatment.time, 0, 0)).format('HH:mm')
                if (!this.intake && this.selectedEpisode.treatmentTime) {
                    duration = this.$moment(this.selectedEpisode.treatmentTime, "HH:mm").format("HH:mm")
                }
                if (!this.intake) {
                    //build treatment array with episode id
                    this.treatmentArray = [{
                        episode: this.selectedEpisode.id,
                        disease: this.selectedEpisode.disease,
                        treatment: this.selectedEpisode.treatment,
                        duration: duration,
                        requiredEquipment: this.selectedEpisode.equipment
                    }]
                } else if (this.intake) {
                    this.treatmentArray = [{
                        disease: this.selectedTreatment.idCondition,
                        treatment: this.selectedTreatment.idIntakeTreatment,
                        duration: duration,
                    }]
                }
                this.dataArray = {
                    settlement: this.selectedEstablishment.id,
                    treatments: this.treatmentArray,
                    days: this.days,
                    preferredDate: this.specificDate,
                }
                this.$store.commit('setPostArray', this.dataArray)
                this.getAppointmentOptions()
            })
        },
        checkSearchType: function (val) {
            let i = 0
            if (val !== 'specific') {
                this.specificDate = null
            }
            if (val === 'specific') {
                for (i; i < this.days.length; i++) {
                    this.days[i] = {
                        id: this.days[i]['id'],
                        dayNr: this.days[i]['dayNr'],
                        day: this.days[i]['day'],
                        enabled: false,
                        timeStart: '06:00:00',
                        timeEnd: '23:00:00'
                    }
                }
            }
            if (val === 'preference') {
                for (i; i < this.days.length; i++) {
                    let enabled = false
                    if (this.days[i]['enabled']) {
                        enabled = true
                    }
                    this.days[i] = {
                        id: this.days[i]['id'],
                        dayNr: this.days[i]['dayNr'],
                        day: this.days[i]['day'],
                        enabled: enabled,
                        timeStart: '06:00:00',
                        timeEnd: '23:00:00'
                    }
                }
            }
            if (val === 'all') {
                for (i; i < this.days.length; i++) {
                    this.days[i] = {
                        id: this.days[i]['id'],
                        dayNr: this.days[i]['dayNr'],
                        day: this.days[i]['day'],
                        enabled: true,
                        timeStart: '06:00:00',
                        timeEnd: '23:00:00'
                    }
                }
            }
            for (i; i < this.daysOpenClosed.length; i++) {
                if (!this.daysOpenClosed[i].show_in_appointmentsystem) {
                    this.days[this.daysOpenClosed[i].day_number].enabled = false;
                }
            }
            this.$store.commit('setDays', this.days)
        },
        getDaysOpenClosed() {
            axios.get(process.env.VUE_APP_API_URL + 'daysOpenClosed/?practice=' + this.practiceCode, {
                params: {logToken: this.$store.getters.getLogToken}
            }).then((response) => {
                let results = response.data;
                this.daysOpenClosed = JSON.parse(JSON.stringify(results.value))
                this.$store.commit('setDaysOpenClosed', this.daysOpenClosed)
            })
        }
    },
    name: "DateSelection",
    computed: {
        practiceCode() {
            return this.$store.state.practiceCode
        },
        selectedEstablishment() {
            return this.$store.state.selectedEstablishment
        },
        selectedEpisode() {
            return this.$store.state.selectedEpisode
        },
        treatments() {
            return this.$store.state.treatments
        },
        selectedTreatment() {
            return this.$store.state.selectedTreatment
        },
        intake() {
            return this.$store.state.intake
        },
        token() {
            return this.$store.state.token
        },
        rescheduleData() {
            return this.$store.getters.getRescheduleData
        },
        idPatient() {
            return this.$store.state.idPatient
        },
        tempIdPatient() {
            return this.$store.state.tempIdPatient
        },
        weeksAhead() {
            return this.$store.getters.getWeeksAhead
        },
        maxDate() {
            const maxDate = new Date();
            maxDate.setDate(maxDate.getDate() + (7 * this.weeksAhead))
            return maxDate
        },
        minDate() {
            let minHoursAhead = this.$store.getters.getMinHoursAhead
            let minDaysAhead = Math.round(minHoursAhead / 24)
            let minDate = new Date();
            minDate.setDate(minDate.getDate() + minDaysAhead)
            return minDate;
        }
    },
}
</script>

<style scoped>

</style>